/** Defines valid product types. */
enum ProductType {
  Footwear,
  Headwear,
  Apparel,
  Accessories,
  Home,
  Miscellany,
  GiftCard
}

export default ProductType;
